import React from "react";
import styled from "styled-components";
import en from "../../language/Eng_Aust.json";

const BottomMenu = () => {
  return (
    <FooterContainer id="visit-us">
      <TopSection>
        <BrandColumn>
          <LogoImage
            src={
              process.env.PUBLIC_URL +
              "/assets/Buttered/Buttered_logo/MainLogo3.webp"
            }
            alt="Buttered Logo"
            loading="lazy"
          />
        </BrandColumn>

        <Column>
          <SectionTitle>{en.bottommenu.exploreTitle}</SectionTitle>
          <LinkList>
            <LinkItem href="/about">{en.bottommenu.about}</LinkItem>
            <LinkItem href="/mainmenu">{en.bottommenu.menu}</LinkItem>
            <LinkItem href="/butteredwholesale">{en.bottommenu.wholesale}</LinkItem>
            <LinkItem href="/delivery/login">{en.bottommenu.staffLogin}</LinkItem>
          </LinkList>
        </Column>
        <Column>
          <SectionTitle>{en.bottommenu.visitTitle}</SectionTitle>
          <ContactInfo>
            <ContactItem>
              <a
                href={`https://www.google.com/maps/place/Buttered+Bakery+%26+Cafe/@-33.8852129,151.1987054,19z/data=!3m1!4b1!4m6!3m5!1s0x6b12afd5e5b12d91:0x820358e326161bf5!8m2!3d-33.885214!4d151.1999231!16s%2Fg%2F11x2slnvpz?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D || "")}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {en.bottommenu?.location}
              </a>
            </ContactItem>
            <ContactItem>
              <a href={`tel:${en.bottommenu?.number}`}>
                {en.bottommenu?.number}
              </a>
            </ContactItem>
              <ContactItem>
              <a
                href={`https://www.instagram.com/buttered_sydney?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw== || "")}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {en.bottommenu?.instagram}
              </a>
            </ContactItem>
            <ContactItem>
              <a href={`mailto:${en.bottommenu?.email}`}>
                {en.bottommenu?.email}
              </a>
            </ContactItem>
          </ContactInfo>
        </Column>
        <Column>
          <SectionTitle>{en.bottommenu.hoursTitle}</SectionTitle>
          <HoursList>
            <HoursItem>
              <span>{en.bottommenu.weekdayLabel}</span>
              <span>{en.bottommenu.weekdayHours}</span>
            </HoursItem>
            <HoursItem>
              <span>{en.bottommenu.weekendLabel}</span>
              <span>{en.bottommenu.weekendHours}</span>
            </HoursItem>
          </HoursList>
        </Column>
      </TopSection>

      <Divider />

      <BottomSection>
        <Copyright>
          © 2025 {en.bottommenu?.group2}. {en.bottommenu.copyrightSuffix}
        </Copyright>
      </BottomSection>
    </FooterContainer>
  );
};

export default BottomMenu;

const FooterContainer = styled.footer`
  background-color: #f5f0e7;
  border-radius: 32px 32px 0 0;
  scroll-margin-top: 20px;
  padding: 50px 5%;
  color: #555;
  font-family: sans-serif;

  @media (max-width: 1024px) {
    padding: 40px 5%;
  }

  @media (max-width: 768px) {
    padding-bottom: calc(100px + env(safe-area-inset-bottom));
  }
`;

const TopSection = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1.2fr 1fr;
  gap: 40px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
    text-align: center;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

const BrandColumn = styled(Column)`
  padding-right: 20px;
`;

const LogoImage = styled.img`
  width: 100%;
  max-width: 280px;
  height: auto;
  margin-bottom: 20px;
  display: block;
`;

const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  margin-top: 0;
`;

const LinkList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const LinkItem = styled.a`
  font-size: 14px;
  color: #666;
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: #333;
  }
`;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const ContactItem = styled.div`
  font-size: 14px;
  color: #666;

  a {
    color: inherit;
    text-decoration: none;
    line-height: 1.5;
  }
  a:hover {
    text-decoration: underline;
  }
`;

const HoursList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

const HoursItem = styled.div`
  display: grid;
  grid-template-columns: 80px 1fr;
  align-items: center;
  font-size: 14px;
  color: #666;
  width: 100%;
  
  & > span:last-child {
    text-align: right;
  }
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 0;
`;

const BottomSection = styled.div`
  padding-top: 30px;
  text-align: center;
`;

const Copyright = styled.p`
  font-size: 12px;
  color: #999;
`;
